import React from 'react'
import { convertTime } from '../../../../utils/timeUtils'

export const TimeCell = ({ value, convert = false }) => {
    if (!value || value === "void") {
        return (
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-[#FEF2F2] border border-[#FECACA] text-[#DC2626]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#DC2626] shrink-0" />
                Void
            </span>
        );
    }
    return (
        <span className="text-[#5a5854]">
            {convert ? convertTime(value) : value}
        </span>
    );
};